import { useState, useCallback, useMemo, useEffect } from "react";

/**
 * Google Drive /file/d/.../view: try several uc/docs/usercontent URLs (Drive often
 * returns HTML virus-scan page for large files on first attempt), then preview iframe.
 */
function DriveVideoPlayer({ previewUrl, streamUrls, streamUrl, streamUrlAlt, className, title }) {
  const urls = useMemo(() => {
    const list = Array.isArray(streamUrls) ? streamUrls.filter(Boolean) : [];
    if (list.length) return list;
    return [streamUrl, streamUrlAlt].filter(Boolean);
  }, [streamUrls, streamUrl, streamUrlAlt]);

  const [stage, setStage] = useState(0);
  const iframeStage = urls.length;

  const urlsKey = useMemo(() => urls.join("|"), [urls]);

  useEffect(() => {
    setStage(0);
  }, [previewUrl, urlsKey]);

  const onVideoError = useCallback(() => {
    setStage((s) => (s < iframeStage ? s + 1 : s));
  }, [iframeStage]);

  if (stage >= iframeStage) {
    return (
      <div className={`d-flex flex-column w-100 h-100 ${className || ""}`} style={{ minHeight: "280px" }}>
        <iframe
          src={previewUrl}
          title={title}
          className="flex-grow-1 w-100 border-0"
          style={{ minHeight: "280px", minWidth: "100%" }}
          allow="autoplay; fullscreen"
          allowFullScreen
        />
      </div>
    );
  }

  const src = urls[stage];
  if (!src) {
    return null;
  }

  return (
    <div className={`d-flex flex-column w-100 h-100 ${className || ""}`} style={{ minHeight: "260px" }}>
      <video
        key={`${stage}-${src}`}
        controls
        playsInline
        className="w-100 flex-grow-1"
        style={{
          objectFit: "contain",
          background: "#111",
          minHeight: "240px",
          maxHeight: "min(70vh, 640px)",
        }}
        onError={onVideoError}
      >
        <source src={src} />
      </video>
    </div>
  );
}

export default DriveVideoPlayer;
